import React, { Component } from "react";
import { Chart as ChartJS, HorizontalBar } from "react-chartjs-2";
import styled from "styled-components";
import Teams from "api/Teams";
import { Modal } from "react-bootstrap";
import Auth from "routes/Auth";
import _ from "lodash";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import Rating from '../rating/index';
import ChartViewMore from "./chart-view-more";

const ChartTitle = styled.div`
  text-align: center;
  font-size: 26px;
  color: #36507e;
  margin-top: -80px;
  margin-bottom: 60px;
`;

const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  width: 100%;
`;

const ModalWrapper = styled(Modal)`
  .modal-dialog {
    width: 1077px !important;
    max-width: 95% !important;
  }

  .modal-content {
    border-radius: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-height: 730px !important;
    max-height: 95% !important;
  }
`;

const ModalHeader = styled(Modal.Header)`
  padding-bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ModalBody = styled(Modal.Body)`
  padding: 10px 40px 25px !important;
`;

const ModalTitle = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 36px;
  line-height: 44px;
  color: #bdbdbd;
  width: 100%;

  ${p =>
    p.align &&
    `
    text-align: ${p.align};
  `}
`;

const ModalQuestion = styled.div`
  font-family: Lato;
  font-size: 20px;
  line-height: 25px;
  color: #000;
  margin-top: 15px;
`;

const ModalFeedbackValue = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 46px;
  line-height: 56px;
  color: #333333;
  padding-right: 20px;
`;

const RatingText = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  color: #bdbdbd;
  margin-bottom: 10px;
`;

const RatingRow = styled.div`
  display: flex;
  align-items: center;
  margin: 10px auto 0;
  max-width: 300px;
`;

const ModalFooter = styled(Modal.Footer)`
  padding: 0 !important;
  height: 75px !important;
  position: relative;
`;

const ContinueButton = styled.button`
  position: absolute;
  bottom: 25px;
  right: 35px;
  display: flex;
  width: 145px;
  height: 45px;
  outline: none;
  cursor: pointer;
  background: #52c5cd;
  border-radius: 4px;
  font-family: Lato;
  font-size: 16px;
  color: #fbfbfb;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;

  .small {
    font-size: 14px;
  }
`;

const AnswerWrapper = styled.div`
  border-bottom: 0.25px solid #828282;
  padding-bottom: 20px;
  margin-top: 35px;
`;

const AnswerRow = styled.div`
  margin-top: 25px;
  border-top: 0.25px solid #828282;
  padding-top: 16px;
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
`;

const AnswerCounter = styled.div`
  width: 85px;
  height: 85px;
  background: rgba(82, 197, 205, 0.25);
  font-family: Lato;
  font-weight: bold;
  font-size: 44px;
  color: #000;
  text-align: center;
  line-height: 85px;
  flex: 0 0 85px;
`;

const AnswerText = styled.div`
  padding-left: 16px;
  font-family: Lato;
  font-size: 16px;
  line-height: 19px;
  color: #000;
  display: flex;
  align-items: center;
  height: 85px;
`;

const BarChartWrapper = styled.div`
  max-width: 530px;
`;

const BackButton = styled.button`
  position: absolute;
  bottom: 25px;
  right: 195px;
  display: flex;
  width: 145px;
  height: 45px;
  outline: none;
  cursor: pointer;
  background: #52c5cd;
  border-radius: 4px;
  font-family: Lato;
  font-size: 16px;
  color: #fbfbfb;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;

  .small {
    font-size: 14px;
  }
`;


const getAllValues = reports => {
  return Object.values(reports)
    .map(report => [
      Number(report.median_user_score.toFixed(2)),
      Number(report.team_average_score.toFixed(2)),
      Number(report.team_median_score.toFixed(2))
    ])
    .reduce((result, currentArray) => [...result, ...currentArray], []);
};

const MODAL_TYPE_INITIAL = 0;
//const MODAL_TYPE_POSITIVE = 1;
//const MODAL_TYPE_NEGATIVE = 2;
const MODAL_TYPE_SELF_REFLECTION = 1;

export default class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSurvey: null,
      currentReport: null,
      currentPage: 0,
      currentType: MODAL_TYPE_INITIAL
    };
  }

  componentWillMount() {
    ChartJS.Tooltip.positioners.custom = elements => {
      if (!elements.length) {
        return false;
      }

      let i, len;
      let y = 0;
      let count = 0;
      let nearestElement;

      for (i = 0, len = elements.length; i < len; ++i) {
        const el = elements[i];
        if (el && el.hasValue()) {
          if (!nearestElement) {
            nearestElement = el;
          }
          const pos = el.tooltipPosition();
          y += pos.y;
          ++count;
        }
      }

      const barOffset = nearestElement
        ? Math.round(nearestElement.getArea() / 45 + 20)
        : 0;

      return {
        x: barOffset + 40,
        y: Math.round(y / count)
      };
    };

    ChartJS.pluginService.register({
      beforeRender: chart => {
        if (chart.config.options.showAllTooltips) {
          chart.pluginTooltips = [];
          chart.config.data.datasets.forEach((_, i) => {
            chart.getDatasetMeta(i).data.forEach((sector, j) => {
              chart.pluginTooltips.push(
                new ChartJS.Tooltip(
                  {
                    _chart: chart.chart,
                    _chartInstance: chart,
                    _data: chart.data,
                    _options: chart.options.tooltips,
                    _active: [sector]
                  },
                  chart
                )
              );
            });
          });

          chart.options.tooltips.enabled = false;
        }
      },

      afterDraw: (chart, easing) => {
        if (chart.config.options.showAllTooltips) {
          if (!chart.allTooltipsOnce) {
            if (easing !== 1) {
              return;
            }

            chart.allTooltipsOnce = true;
          }

          chart.options.tooltips.enabled = true;
          ChartJS.helpers.each(chart.pluginTooltips, tooltip => {
            tooltip.initialize();
            tooltip.update();
            tooltip.pivot();
            tooltip.transition(easing).draw();
          });
          chart.options.tooltips.enabled = false;
        }
      }
    });
  }

  showModal = (currentReport, stage) => {
    const { surveys } = this.props;
    const currentSurvey = surveys.find(survey => survey.stage === stage);
    this.setState({
      currentReport,
      currentSurvey,
      currentPage: 0,
      currentType: MODAL_TYPE_INITIAL
    });
  };

  hideModal = () => {
    this.setState({
      currentReport: null,
      currentSurvey: null
    });
  };

  getQuestions = currentType => {
    const { currentReport, currentSurvey } = this.state;

    if (!currentReport || !currentSurvey) {
      return [];
    }

    let questions = [];
    if (currentType === MODAL_TYPE_INITIAL) {
      questions = currentReport.average_user_score_question;
    } /*else if (currentType === MODAL_TYPE_POSITIVE) {
      const ids = currentSurvey.questions
        .filter(
          question =>
            question.answer_type === "freeform" &&
            question.category === "communication"
        )
        .map(question => question.id);
      questions = currentReport.freeform_answers.filter(answer =>
        ids.includes(answer.survey_question)
      );
    } else if (currentType === MODAL_TYPE_NEGATIVE) {
      const ids = currentSurvey.questions
        .filter(
          question =>
            question.assessment_type === "negative" &&
            question.category !== "self_assessment"
        )
        .map(question => question.id);
      questions = currentReport.freeform_answers.filter(answer =>
        ids.includes(answer.survey_question)
      );
    }*/ else if (currentType === MODAL_TYPE_SELF_REFLECTION) {
      const ids = currentSurvey.questions
        .filter(question => question.category === "self_assessment")
        .map(question => question.id);
      questions = currentReport.freeform_answers.filter(answer =>
        ids.includes(answer.survey_question)
      );
    }

    const needSkip = currentSurvey.questions
      .filter(i => i.most_valuable === true || i.work_together === true)
      .map(i => i.id);

    if (currentType !== MODAL_TYPE_INITIAL) {
      questions = questions.filter(i => !needSkip.includes(i.survey_question));
    }

    return _.chunk(questions, 4);
  };

  get questions() {
    const { currentType } = this.state;

    return this.getQuestions(currentType);
  }

  get questionsList() {
    const { currentPage } = this.state;
    const questions = this.questions;
    const result = currentPage < questions.length ? questions[currentPage] : [];
    const team = Teams.currentTeam();
    const players = Teams.players();
    const teammates = players
      .filter(player => {
        return (
          player.team === team.id &&
          player.user.id !== parseInt(Auth.getUserId(), 10)
        );
      })
      .map(teammate => teammate.user.username);

    return result.filter(answer => !teammates.includes(answer.text));
  }

  nextPage = () => {
    const { currentPage, currentType } = this.state;

    if (currentPage < this.questions.length - 1) {
      this.setState({
        currentPage: currentPage + 1
      });
    } else if (currentType === 0) {
      this.setState({
        currentPage: 0,
        currentType: currentType + 1
      });
    }
  };

  get isFirstPage() {
    const { currentPage, currentType } = this.state;

    return currentPage === 0 && currentType === MODAL_TYPE_INITIAL
      ? true
      : false;
  }

  get isLastPage() {
    const { currentPage, currentType } = this.state;

    if (currentPage === this.questions.length - 1) {
      if (currentType === 0) {
        const nextQuestions = this.getQuestions(currentType + 1);

        if (nextQuestions.length === 0) {
          return true;
        }
      } else {
        return true;
      }
    }

    return false;
  }

  get modalTitle() {
    const { currentType } = this.state;
    const titles = {
      [MODAL_TYPE_INITIAL]: "Initial Feedback",
      //[MODAL_TYPE_POSITIVE]: "What You Did Well",
      //[MODAL_TYPE_NEGATIVE]: "What You Can Improve",
      [MODAL_TYPE_SELF_REFLECTION]: "Self Reflection"
    };

    return titles[currentType];
  }

  goBack = () => {
    const { currentPage, currentType } = this.state;

    if (currentPage > 0) {
      this.setState({
        currentPage: currentPage - 1
      });
    } else if (currentType > 0) {
      const prevQuestions = this.getQuestions(currentType - 1);

      this.setState({
        currentPage: prevQuestions.length - 1,
        currentType: currentType - 1
      });
    }
  };

  render() {
    const { title, reports, isSurveyFinished } = this.props;
    const { currentReport, currentPage, currentType } = this.state;
    const allValues = getAllValues(reports);
    const isBarChart = Object.keys(reports).length === 1 ? true : false;
    const options = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            ticks: {
              min: 0,
              max: Math.max.apply(null, allValues),
              callback: () => ""
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: false
            },
            ticks: {
              callbacks: () => ""
            }
          }
        ]
      },
      tooltips: {
        enabled: true,
        mode: "point",
        position: "custom",
        backgroundColor: "transparent",
        bodyFontFamily: "Lato",
        bodyFontSize: 16,
        bodyFontStyle: "bold",
        bodyFontColor: "#2a4169",
        bodyAlign: "center",
        displayColors: false,
        xPadding: 0,
        yPadding: 0,
        bodySpacing: 0,
        callbacks: {
          title: () => "",
          label: tooltipItem => {
            return (Math.round(tooltipItem.value * 100) / 100).toFixed(2);
          }
        }
      },
      showAllTooltips: true,
      layout: {
        padding: {
          right: 40
        }
      }
    };

    const getReportForBar = (key, label, backgroundColor) => ({
      label,
      data: Object.values(
        Object.keys(reports).reduce(
          (result, stage) => ({
            ...result,
            [stage]: Number(reports[stage][key].toFixed(2))
          }),
          {}
        )
      ),
      backgroundColor,
      borderWidth: 0,
      minBarLength: 20,
      barPercentage: 0.8,
      maxBarThickness: 45
    });

    const data = {
      labels: [""],
      datasets: [
        getReportForBar("median_user_score", "You", Teams.currentTeamColor()),
        getReportForBar("team_average_score", "Team Average", "#eee"),
        getReportForBar("team_median_score", "Team Median", "#c4c4c4")
      ],
      options
    };
    const surveys = this.props.surveys
      .filter(survey => isSurveyFinished(survey));
    let surveysStages = surveys
      .map(survey => survey.stage);
    if (surveysStages.length < 3) {
      for (let i = 0; i < 3 - surveysStages.length; i++) {
        surveysStages.push("");
      }
    }

    const stages = {
      initial: "Initial Feedback",
      second: "Second Feedback",
      final: "Final Feedback"
    };
    const tmpData = Object.keys(reports).map(stage => ({
      name: stages[stage],
      You: Number(reports[stage].median_user_score.toFixed(2)),
      "Team Average": Number(reports[stage].team_average_score.toFixed(2)),
      "Team Median": Number(reports[stage].team_median_score.toFixed(2))
    }));

    let initial = tmpData.find(i => i.name === "Initial Feedback");
    if (!initial) {
      initial = {
        name: "Initial Feedback",
        You: null,
        "Team Average": null,
        "Team Median": null
      };
    }

    let second = tmpData.find(i => i.name === "Second Feedback");

    let final = tmpData.find(i => i.name === "Final Feedback");

    let chartData = [initial];
    if (second) {
      chartData.push(second);
    }
    if (final) {
      chartData.push(final);
    }
    const isShowModal = currentReport ? true : false;

    return (
      <div>
        <ChartTitle>{title}</ChartTitle>
        {!isBarChart && (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={chartData}
              margin={{
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              }}
            >
              <Tooltip />
              <XAxis
                dataKey="name"
                padding={{ top: 30, left: 30, right: 30, bottom: 30 }}
                hide={true}
              />
              <YAxis
                hide={true}
                domain={[
                  Math.min.apply(null, allValues) * 0.9,
                  Math.max.apply(null, allValues) * 1.1
                ]}
              />
              <Line
                type="monotone"
                dataKey="You"
                stroke={Teams.currentTeamColor()}
                dot={false}
                activeDot={false}
                label={{
                  fontFamily: "Lato",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#222"
                }}
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey="Team Average"
                stroke="#eee"
                dot={false}
                activeDot={false}
                label={{
                  fontFamily: "Lato",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#222"
                }}
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey="Team Median"
                stroke="#c4c4c4"
                dot={false}
                activeDot={false}
                label={{
                  fontFamily: "Lato",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#222"
                }}
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
        {isBarChart && (
          <BarChartWrapper>
            <HorizontalBar data={data} options={options} />
          </BarChartWrapper>
        )}
        <ButtonsRow>
          {surveys.map((survey, index) =>
            <ChartViewMore key={index} survey={survey} reports={reports} />
          )}
        </ButtonsRow>
        {isShowModal === true && (
          <ModalWrapper show={true} onHide={this.hideModal}>
            <ModalHeader closeButton>
              <ModalTitle align="left">{this.modalTitle}</ModalTitle>
              {currentType === MODAL_TYPE_INITIAL && (
                <ModalTitle align="right">Collaboration</ModalTitle>
              )}
            </ModalHeader>
            <ModalBody>
              {currentType === MODAL_TYPE_INITIAL &&
                this.questionsList.map(({ question, value: rating }, i) => (
                  <div key={`${currentType}-${currentPage * 4 + i + 1}`}>
                    <ModalQuestion>
                      {currentPage * 4 + i + 1}. {question}
                    </ModalQuestion>
                    <RatingRow>
                      <ModalFeedbackValue>
                        {Number(rating.toFixed(2))}
                      </ModalFeedbackValue>
                      <div>
                        <RatingText>Average Rating</RatingText>
                        <Rating value={rating} />
                      </div>
                    </RatingRow>
                  </div>
                ))}
              {currentType !== MODAL_TYPE_INITIAL && (
                <AnswerWrapper>
                  {this.questionsList.map(({ text }, i) => (
                    <AnswerRow
                      key={`${currentType}-${currentPage * 4 + i + 1}`}
                    >
                      <AnswerCounter>{currentPage * 4 + i + 1}</AnswerCounter>
                      <AnswerText>{text}</AnswerText>
                    </AnswerRow>
                  ))}
                </AnswerWrapper>
              )}
            </ModalBody>
            <ModalFooter>
              {!this.isFirstPage && (
                <BackButton onClick={this.goBack}>
                  <span className="small">◀</span>
                  <span>Back</span>
                </BackButton>
              )}
              <ContinueButton
                onClick={this.isLastPage ? this.hideModal : this.nextPage}
              >
                <span>{this.isLastPage ? "Close" : "Continue"}</span>
                <span className="small">▶</span>
              </ContinueButton>
            </ModalFooter>
          </ModalWrapper>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/peer-review/chart.js